import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const AssetRoute: Route = {
  path: 'asset',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/asset.component').then((m) => m.AssetComponent),
    },
    {
      path: ':type',
      loadComponent: () => import('./pages/asset.component').then((m) => m.AssetComponent),
    },
    {
      path: ':type/:id',
      loadComponent: () => import('./pages/asset-details.component').then((m) => m.AssetDetailsComponent),
    },
    {
      path: 'workspace/:id/:assetId',
      loadComponent: () => import('./pages/workspace-asset-details.component').then((m) => m.WorkspaceAssetDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
